import { createCopyKey } from '../../../../shared/utils/createCopyKey';

export const ANCHORS_BAR_COPY_PREFIX = 'logged_out_homepage.sandbox.anchors';

export const getCopyKey = createCopyKey(ANCHORS_BAR_COPY_PREFIX);

export const ANCHORS_BAR_HEIGHT = '66px';

export const ANCHORS_BAR_SELECTOR = '[data-anchors-bar]';
